import React from 'react'

export default function Learning({learning}) {
  const { icon, title, description } = learning
  return (
    <div className="learning">
      <div className="icon_container">
        <img src={icon} alt="Icon" />
      </div>
      <h3 className="learning_title">{title}</h3>
      <p className="text">{description}</p>
    </div>
  )
}
